module.exports = __webpack_public_path__ + "assets/img/feature-5029767c.png";